import ApexCharts from 'apexcharts';

export default data => ({
    chart: null,

    init() {
        const { priceHistory, minPrice, maxPrice, id: listingId } = data;

        // Destroy any existing chart instance
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }

        const options = {
            series: [
                {
                    name: 'Maxim',
                    data: priceHistory.map(item => ({
                        x: item.date,
                        y: item.max_price,
                    })),
                },
                {
                    name: 'Minim',
                    data: priceHistory.map(item => ({
                        x: item.date,
                        y: item.min_price,
                    })),
                },
            ],
            chart: {
                height: 250,
                type: 'line',
                zoom: {
                    enabled: false,
                },
                toolbar: {
                    show: false,
                },
                animations: {
                    enabled: false,
                },
            },
            stroke: {
                curve: 'smooth',
                width: 2,
                lineCap: 'round',
                smooth: true,
            },
            colors: ['#F59E0B', '#3B82F6'],
            markers: {
                size: 0,
                strokeWidth: 0,
                showNullDataPoints: false,
                hover: {
                    size: 6,
                    sizeOffset: 0,
                },
                discrete: [
                    {
                        seriesIndex: 0,
                        dataPointIndex: 0,
                        fillColor: '#F59E0B',
                        strokeColor: '#F59E0B',
                        size: 6,
                        shape: 'diamond',
                    },
                    {
                        seriesIndex: 0,
                        dataPointIndex: priceHistory.length - 1,
                        fillColor: '#F59E0B',
                        strokeColor: '#F59E0B',
                        size: 6,
                        shape: 'diamond',
                    },
                    {
                        seriesIndex: 1,
                        dataPointIndex: 0,
                        fillColor: '#3B82F6',
                        strokeColor: '#3B82F6',
                        size: 6,
                        shape: 'diamond',
                    },
                    {
                        seriesIndex: 1,
                        dataPointIndex: priceHistory.length - 1,
                        fillColor: '#3B82F6',
                        strokeColor: '#3B82F6',
                        size: 6,
                        shape: 'diamond',
                    },
                ],
            },
            grid: {
                borderColor: '#E2E8EE',
                xaxis: {
                    lines: {
                        show: false,
                    },
                },
                yaxis: {
                    lines: {
                        show: true,
                    },
                },
            },
            legend: {
                show: true,
                position: 'top',
                horizontalAlign: 'right',
                offsetY: -5,
                markers: {
                    width: 8,
                    height: 8,
                    radius: 8,
                },
            },
            tooltip: {
                shared: true,
                custom: function ({ seriesIndex, dataPointIndex, w }) {
                    const data = priceHistory[dataPointIndex];
                    const formatPrice = price => price.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                    return `
                        <div class="text-xs">
                            <div class="bg-gray-100 text-center py-1 px-2 rounded mb-2">${data.date}</div>
                            <div class="flex items-center gap-1 px-2">
                                <span class="w-3 h-3 inline-block rounded-full" style="background: #F59E0B"></span>
                                <span>Maxim: <span class="font-bold">${formatPrice(data.max_price)} €</span></span>
                            </div>
                            <div class="flex items-center gap-1 px-2 py-2">
                                <span class="w-3 h-3 inline-block rounded-full" style="background: #3B82F6"></span>
                                <span>Minim: <span class="font-bold">${formatPrice(data.min_price)} €</span></span>
                            </div>
                        </div>
                    `;
                },
            },
            xaxis: {
                type: 'category',
                tickPlacement: 'on',
                axisBorder: {
                    show: false,
                },
                labels: {
                    style: {
                        colors: '#7A8993',
                        fontSize: '12px',
                    },
                    offsetY: 5,
                    formatter: function (value, timestamp, opts) {
                        const index = priceHistory.findIndex(item => item.date === value);
                        return index === 0 || index === priceHistory.length - 1 ? value : '';
                    },
                },
                axisTicks: {
                    show: false,
                },
            },
            yaxis: {
                min: Math.floor(minPrice * 0.95),
                max: Math.ceil(maxPrice * 1.05),
                labels: {
                    style: {
                        colors: '#7A8993',
                        fontSize: '12px',
                    },
                    formatter: value =>
                        `${Math.round(value)
                            .toString()
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} €`,
                },
            },
        };

        const chartElement = document.querySelector(`#listingPriceHistoryChart-${listingId}`);
        if (chartElement) {
            this.chart = new ApexCharts(chartElement, options);
            this.chart.render();
        }
    },

    destroy() {
        if (this.chart) {
            this.chart.destroy();
            this.chart = null;
        }
    },
});
